import * as THREE from 'three';
import CameraControls from 'camera-controls';
import SidePanel from './SidePanel';
import messages from '@messages'; // For multilanguage

CameraControls.install({ THREE: THREE });

export default class CameraTransition {
    constructor(experience, scene, camera, cameraControls, hotspots, points, locations, placeholders, teleports, delta, renderer, sizes, time, raycaster, resources, frustum, cameraViewProjectionMatrix) {
        this.experience = experience;
        this.scene = scene;
        this.camera = camera;
        this.cameraControls = cameraControls;
        // this.resources = resources
        this.hotspots = hotspots

        this.points = points;
        // this.locations = teleports.locations;
        this.placeholderData = placeholders;

        this.teleports = teleports
        this.placeholders = this.teleports.placeholders;

        this.raycaster = raycaster
        this.resources = resources
        this.frustum = frustum
        this.cameraViewProjectionMatrix = cameraViewProjectionMatrix

        // TODO: Could be moved to SidePanel for full seperation
        document.addEventListener("placeholderClicked", (event) => {
            if (event.detail.placeholder.info) {
                const point = `.point-${event.detail.placeholder.id}`
                const sidePanel = document.querySelector(point)

                if (sidePanel) {
                    this.sidePanel.showContent(sidePanel); // SidePanel
                }

                // Kinda useless since it can't autoplay
                // if (sidePanel.parentElement.classList.contains('video')) {
                //     this.sidePanel.playFullscreen(sidePanel.parentElement)
                // }

            }

            // Since we use a loading screen for bezoekerscentrum, we don't need the transition
            // if (event.detail.placeholder.id == 'bezoekerscentrum') {
            //     this.transitionTo(event.detail.placeholder.position, event.detail.placeholder.target, false);
            // }

            // Add the location to the class for CSS loading-screen styling
            document.getElementById('loading-screen').classList.remove(this.previousLocation)
            document.getElementById('loading-screen').classList.add(event.detail.placeholder.id)
            this.previousLocation = event.detail.placeholder.id

            // Adding url change on click based on the id only if it's not a spot or info point
            // TODO: Use the environment variable for the id so it's dependent on language
            if (event.detail.placeholder.location) {
                const id = event.detail.placeholder.id;
                const slug = messages.points[id]?.slug || id; // Pull data from nl/de.json
                updateURL(slug);
            }

            if (event.detail.placeholder.spot) {
                this.cameraControls.saveState()
            }

            function updateURL(id) { // This updates the url when clicking placeholder
                // console.log(event)

                let newUrl = null;

                if (id == 'home') {
                    newUrl = `${window.location.origin}`;
                }

                else {
                    newUrl = `${window.location.origin}/${id}`;
                }

                window.history.pushState({ location: id }, '', newUrl);
            }

            this.cameraControls.saveState() // Save the current settings before changing

            // this.changeControls(event.detail.placeholder.id)

            // console.log(event.detail.placeholder.id)
        });

        this.delta = delta;
        this.renderer = renderer;
        this.sizes = sizes;
        this.clock = new THREE.Clock()

        // Initialize the SidePanel instance
        this.sidePanel = new SidePanel(cameraControls, renderer, camera, time, scene);

        // Changing speed of the transition
        // this.cameraControls.maxSpeed = 10
        // this.cameraControls.smoothTime = 0.3
        this.cameraControls.azimuthRotateSpeed = 0.6
        this.cameraControls.polarRotateSpeed = 0.6


        // this.cameraControls.truck = false // Gives errors
        // this.cameraControls.mouseButtons.right = CameraControls.ACTION.NONE;
        // this.cameraControls.mouseButtons.shiftLeft = CameraControls.ACTION.NONE;
        // this.cameraControls.touches.two = CameraControls.ACTION.NONE;

        this.cameraControls.infinityDolly = true

        this.locationId = null

        this.setupEventListeners();
        this.animate(this.cameraControls);
    }

    setupEventListeners(cameraControls) {
        // let isHome = true;

        for (const location of this.placeholders) {
            if (location.location) {
                // Handle when location in URL (Start Location)
                const pathParts = window.location.pathname.split('/').filter(Boolean);
                let urlLocation = pathParts.length > 0 ? pathParts[pathParts.length - 1] : null;
                // Custom event to push the startLocation to prevent transitions when it's the starting location

                // Match urlLocation to right language slug
                let matchedId = null;
                for (const [id, data] of Object.entries(messages.points)) {
                    if (data.slug === urlLocation) {
                        matchedId = id;
                        break;
                    }
                }
                if (location.id == matchedId) { // Modified for multilingual
                    this.transitionTo(location.position, location.target, false);
                    document.dispatchEvent(new CustomEvent("placeholderClicked", {
                        detail: {
                            placeholder: location, // Pass the clicked placeholder
                            // event: event, // Pass the original event if needed
                            startLocation: matchedId
                        }
                    }));
                    this.cameraControls.saveState() // Save the current settings before changing

                }

                // Need to also dispatchEvent if startLocation is home
                else if (urlLocation == null && location.id == 'home') {
                    this.transitionTo(location.position, null, false);
                    document.dispatchEvent(new CustomEvent("placeholderClicked", {
                        detail: {
                            placeholder: location, // Pass the clicked placeholder
                            // event: event, // Pass the original event if needed
                            id: 'home',
                            startLocation: 'home'
                        }
                    }));
                    this.cameraControls.saveState() // Save the current settings before changing

                }

                // console.log(location.id)


                // Menu
                const element = document.querySelectorAll(`.point-${location.id}`)[0]

                element.addEventListener('click', (event) => {
                    // When click on menu item, match with location.id and get its coordinates to transition to.
                    this.transitionTo(location.position, location.target);

                    if (location.id == 'home') {
                        // So it pivots around 0, 0, 0 because if no target, coordinates 0, 0, 0.
                        this.transitionTo(location.position, null);
                    }

                    document.dispatchEvent(new CustomEvent("placeholderClicked", {
                        detail: {
                            placeholder: location, // Pass the clicked placeholder
                            event: event, // Pass the original event if needed
                            startLocation: 'home'
                        }
                    }));

                    this.cameraControls.saveState() // Save the current settings before changing
                });

                const markers = document.querySelectorAll(`[class^=point-marker-${location.id}]`)
                for (const marker of markers) {
                    marker.addEventListener('click', (event) => {
                        // When click on menu item, match with location.id and get its coordinates to transition to.
                        // console.log(this.placeholders.locationId)
                        this.transitionTo(location.position, location.target);

                        // // if (location.id == 'home') {
                        // // So it pivots around 0, 0, 0 because if no target, coordinates 0, 0, 0.
                        // this.transitionTo(location.position, null);
                        // // }

                        document.dispatchEvent(new CustomEvent("placeholderClicked", {
                            detail: {
                                placeholder: location, // Pass the clicked placeholder
                                event: event, // Pass the original event if needed
                                startLocation: 'home'
                            }
                        }));

                        this.cameraControls.saveState() // Save the current settings before changing
                    });
                }
            }
        }

        for (const point of this.points) {
            // Don't need transitions if it's a link
            if (!point.element.classList.contains('link')) {
                const rect = new THREE.Mesh(new THREE.PlaneGeometry(.5, .5), new THREE.MeshBasicMaterial({ color: 0x00ff00, transparent: true, opacity: 0.7, side: THREE.DoubleSide }))
                rect.position.set(point.position.x, point.position.y, point.position.z)
                // rect.rotation.set(Math.PI / 4, Math.PI / 4, 0); // Base rotation on where the target is
                // this.scene.add(rect);

                if (!point.target) {
                    point.target = { x: 0, y: 0, z: 0 }
                }

                // if (!point.tracked) {
                //     const locationMarker = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), new THREE.MeshStandardMaterial({ color: 0xffffff, side: THREE.DoubleSide }))
                //     locationMarker.position.set(point.position.x - 0, point.position.y, point.position.z - 1)
                //     // this.scene.add(locationMarker)
                //     locationMarker.castShadow = true;
                //     locationMarker.castShadow.intensity
                // }

                const _cameraPosition = new THREE.Vector3();

                point.element.addEventListener('click', () => {

                    if (!point.location) { this.transitionRect(this.camera, _cameraPosition, point) }
                    if (point.element.parentElement.querySelector('.side-panel')) {
                        this.sidePanel.showContent(point.element); // SidePanel
                    }

                    // Adding url change on click based on the id
                    // Only do this for locations right?
                    // updateURL(point.id);

                    // function updateURL(id) {
                    //     const newUrl = `${window.location.origin}/${id}`;
                    //     window.history.pushState({ location: id }, '', newUrl);
                    //     // currentLocationId = id;
                    // }
                });
            }
        }

        // For the Teleports
        // for (const placeholder of this.placeholders) {
        //     if (placeholder.info) {
        //         console.log('yu')

        //         placeholder.addEventListener('click', () => {
        //             // Run through HTML to find the appropriate element to activate
        //             const point = `.point-${placeholder.id}`
        //             const sidePanel = document.querySelector(point).parentElement.querySelector(".side-panel")
        //             const menu = document.querySelector(".menu.primary")

        //             // this.cameraControls.saveState() // Save the current settings before changing
        //             // this.transitionRect(this.camera, _cameraPosition, placeholder)
        //             if (sidePanel) {
        //                 console.log('yu')
        //                 this.sidePanel.showContent(sidePanel); // SidePanel
        //             }
        //         });
        //     }
        // }

        // Set up your keyboard controls
        // TODO: This should really be in camera.js not cameraTransition.js, but can't get it to work without conflicting with the update/animate
        // document.addEventListener('keydown', (event) => {
        //     switch (event.key) {
        //         case 'w':
        //             this.cameraControls.forward(1, true);  // Move forward
        //             break;
        //         case 's':
        //             this.cameraControls.forward(-1, true);  // Move backward
        //             break;
        //         case 'a':
        //             this.cameraControls.truck(-1, 0, true);  // Move left
        //             break;
        //         case 'd':
        //             this.cameraControls.truck(1, 0, true);  // Move right
        //             break;
        //         case 'ArrowUp':
        //             this.cameraControls.rotate(0, -0.1, true);  // Rotate left
        //             break;
        //         case 'ArrowDown':
        //             this.cameraControls.rotate(0, 0.1, true);  // Rotate right
        //             break;
        //         case 'ArrowRight':
        //             this.cameraControls.rotate(.1, 0, true);  // Rotate right
        //             break;
        //         case 'ArrowLeft':
        //             this.cameraControls.rotate(-.1, 0, true);  // Rotate right
        //             break;
        //     }
        // });
    }

    transitionRect(camera, _cameraPosition, point) {
        const cameraPosition = _cameraPosition.copy(point.target);

        if (!point.cameraOffset) {
            point.cameraOffset = 0.1
        }

        if (point.cameraOffset) {
            // this.cameraControls.truck(Math.sin(this.sizes.width - 600), 0, true)
        }

        if (point.tracked == true) {
            // Goal: aim it at a very far point, moveTo the model with a slight offset
            // Get world position of the animated child model
            const modelWorldPosition = new THREE.Vector3();
            point.model.getWorldPosition(modelWorldPosition);

            // Set new camera position
            const newPosX = camera.position.x + (modelWorldPosition.x - camera.position.x) * point.cameraOffset;
            const newPosY = camera.position.y + (modelWorldPosition.y - camera.position.y) * point.cameraOffset;
            const newPosZ = camera.position.z + (modelWorldPosition.z - camera.position.z) * point.cameraOffset;

            // Move camera
            // this.cameraControls.moveTo(newPosX, newPosY, newPosZ, true);
            // this.cameraControls.setTarget(modelWorldPosition.x, modelWorldPosition.y, modelWorldPosition.z, true);


            const targetPos = modelWorldPosition.clone();
            camera.position.lerp(targetPos, point.cameraOffset);
            this.cameraControls.moveTo(camera.position.x, camera.position.y, camera.position.z, true);
            this.cameraControls.setTarget(targetPos.x, targetPos.y, targetPos.z, true);

        }

        else {
            cameraControls.setLookAt(
                point.position.x, point.position.y, point.position.z,
                cameraPosition.x, cameraPosition.y, cameraPosition.z,
                true,
            );

            cameraControls.moveTo((point.position.x * point.cameraOffset) + (point.target.x * (1 - point.cameraOffset)), (point.position.y * point.cameraOffset) + (point.target.y * (1 - point.cameraOffset)), (point.position.z * point.cameraOffset) + (point.target.z * (1 - point.cameraOffset)), true) // Keeps it in line
        }

        if (point.cameraOffset) {
            // this.cameraControls.truck(Math.sin(this.sizes.width - 600), 0, true)
            // this.truck.offset = Math.sin(this.sizes.width - 600)

        }
    }

    async transitionTo(position, target, smooth = true) { // Smooth = true sets the default to true if nothing passed
        // const offset = 1.05 // Avoid it glitching when the camera goes to coordinates of the point. Glitching because there's no normal?

        if (!target) {
            // target = { x: position.x, y: position.y, z: position.z } // Set a default target (center) if there's no target in Hotspots
            target = { x: 0, y: 0, z: 0 }
        }

        cameraControls.setLookAt( // This is basically, setPosition (camera position) and setTarget (center)
            // this.controls.setLookAt( 
            position.x,
            position.y,
            position.z,
            target.x,
            target.y,
            target.z,
            smooth
        );
    }

    animate() {
        const animateLoop = () => {
            const delta = this.clock.getDelta();

            // Update camera controls with delta time
            this.cameraControls.update(delta);

            // Render the scene
            this.renderer.instance.render(this.scene, this.camera);

            // TODO: Fix hotspots ... but this is the right place to fix it.
            this.hotspots.update(this.camera, this.sizes, this.points); // Don't need raycast, frustrum, sceneReady (because already running camera transition when sceneReady)
            this.teleports.update();

            // this.renderer.instance.render(this.scene, this.camera);
            // this.renderer.instance.setSize(window.clientWidth, window.clientHeight)

            requestAnimationFrame(animateLoop);
        };

        animateLoop();
    }
}